<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {usePaySlipStore} from "@/stores/PaySlip";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    name: "CloseForm",
    setup() {
        const {$route} = useTools();
        const {dialog, loading, overlay} = useSharedData();
        const {getBack} = useSharedMethod();
        const paySlipStore = usePaySlipStore();

        const paySlip = ref({});

        function findById(id) {
            loading.value = true;
            axios.get(`/payments/${id}`).then(response => {
                paySlip.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        const {priceFormat} = useSharedMethod();

        function close() {
            loading.value = true;
            axios.put(`/payments/closed/${paySlip.value.id}`).then(response => {
                response.data.details.forEach((detail) => {
                    if (detail.printIn !== "5") {
                        response.data[detail.code] = priceFormat(detail.value);
                    }
                });
                paySlipStore.updatePaySlip(response.data);
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }


        onMounted(() => findById($route.params.id));

        return {
            dialog,
            loading,
            overlay,
            paySlip,
            close,
            getBack
        }
    }
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="600"
    >
        <v-card flat>
            <w-dialog-toolbar lock-action/>
            <w-overlay
                :loading="loading"
                :overlay="overlay"
                lock-action
                @lock="close"
                @cancel="overlay = false"
            />
            <v-card-text>
                <v-row align="center" justify="center" style="height: 200px;">
                    <h2 class="text-center">
                        {{ $t('pay_slip.ask_for_close') }}
                        <span>
                            {{ `${paySlip.workerLastName} ${paySlip.workerFirstName}` }}
                        </span>
                    </h2>
                </v-row>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-lock
                    show
                    :loading="loading"
                    @press="overlay = true"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>